import MainApp from './index'
import router from '../route/router'
import { Query } from '@zz-biz/utils'
import pageIdConfig from '../page.config.js'

const app = new MainApp(router)

const legoParams = { ...pageIdConfig }
if (Query.get('fromchannel')) legoParams.mchannel = Query.get('fromchannel')
if (Query.get('metricKey')) legoParams.metricKey = Query.get('metricKey')

app.init(legoParams)
